(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-item"] && !Shopify.designMode) return;
  try {
    class AccordionList extends HTMLElement {
    connectedCallback() {
      const multiple = this.hasAttribute('multiple');
      const open = Array.from(this.querySelectorAll('.accordion-item.is-open'));

      if (!multiple) open.slice(1).forEach((item) => this.setOpen(item, false));

      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('.accordion-item__trigger');

        if (!trigger || !this.contains(trigger)) return;

        const item = trigger.closest('.accordion-item');
        const willOpen = !item.classList.contains('is-open');

        if (willOpen && !multiple) {
          this.querySelectorAll('.accordion-item.is-open').forEach((other) => {
            if (other !== item) this.setOpen(other, false);
          });
        }

        this.setOpen(item, willOpen);
      });
    }

    setOpen(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector('.accordion-item__trigger').setAttribute('aria-expanded', String(open));
    }
  }

  if (!customElements.get('accordion-list')) {
    customElements.define('accordion-list', AccordionList);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["content-slider"] && !Shopify.designMode) return;
  try {
    class ContentSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');

      if (!this.track) return;

      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.originals = Array.from(this.track.children);
      this.loops = this.hasAttribute('loop') && this.originals.length > 1;
      this.cloneCount = 0;
      this.touching = false;
      this.realIndex = 0;

      this.bindControls();

      if (this.loops) this.buildClones();

      this.slides = Array.from(this.track.children);

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.track.addEventListener('scrollend', () => this.settle());
      this.track.addEventListener('touchstart', () => (this.touching = true), { passive: true });
      this.track.addEventListener('touchend', () => this.releaseTouch());
      this.track.addEventListener('touchcancel', () => this.releaseTouch());

      this.resizeObserver = new ResizeObserver(() => this.snapToIndex(this.realIndex, 'instant'));
      this.resizeObserver.observe(this.track);

      requestAnimationFrame(() => this.snapToIndex(0, 'instant'));

      this.setupAutoplay();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();

      this.teardownAutoplay();
    }

    setupAutoplay() {
      this.autoplayDelay = Number(this.getAttribute('autoplay')) || 0;

      if (!this.autoplayDelay || this.originals.length < 2 || this.autoplayHandlers) return;

      this.autoplayPause = 10000;
      this.autoplayHovered = false;
      this.autoplayInView = false;
      this.autoplayPausedUntil = 0;
      this.autoplayReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoplayHoverPause = this.hasAttribute('autoplay-hover-pause');
      this.autoplayHoverTarget = this.closest('.shopify-section') || this;

      const manual = () => this.pauseAutoplay();

      this.autoplayHandlers = {
        manual,
        wheel: (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) manual();
        },
        enter: (event) => {
          if (event.pointerType !== 'mouse') return;

          this.autoplayHovered = true;
          clearTimeout(this.autoplayTimer);
        },
        leave: (event) => {
          if (event.pointerType !== 'mouse') return;

          this.autoplayHovered = false;
          this.scheduleAutoplay();
        },
      };

      ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown'].forEach((type) => {
        this.track.addEventListener(type, manual, { passive: true });
      });
      this.track.addEventListener('wheel', this.autoplayHandlers.wheel, { passive: true });
      this.addEventListener('click', manual);
      this.addEventListener('focusin', manual);
      if (this.autoplayHoverPause) {
        this.autoplayHoverTarget.addEventListener('pointerenter', this.autoplayHandlers.enter);
        this.autoplayHoverTarget.addEventListener('pointerleave', this.autoplayHandlers.leave);
      }

      this.autoplayObserver = new IntersectionObserver((entries) => {
        this.autoplayInView = entries[entries.length - 1].isIntersecting;
      });
      this.autoplayObserver.observe(this);

      this.scheduleAutoplay();
    }

    teardownAutoplay() {
      clearTimeout(this.autoplayTimer);

      if (!this.autoplayHandlers) return;

      if (this.autoplayObserver) this.autoplayObserver.disconnect();

      ['touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown'].forEach((type) => {
        this.track.removeEventListener(type, this.autoplayHandlers.manual);
      });
      this.track.removeEventListener('wheel', this.autoplayHandlers.wheel);
      this.removeEventListener('click', this.autoplayHandlers.manual);
      this.removeEventListener('focusin', this.autoplayHandlers.manual);
      if (this.autoplayHoverPause) {
        this.autoplayHoverTarget.removeEventListener('pointerenter', this.autoplayHandlers.enter);
        this.autoplayHoverTarget.removeEventListener('pointerleave', this.autoplayHandlers.leave);
      }
      this.autoplayHandlers = null;
    }

    /* One timer per carousel: scheduling always replaces the pending one. */
    scheduleAutoplay() {
      clearTimeout(this.autoplayTimer);

      if (this.autoplayHovered) return;

      const wait = Math.max(this.autoplayDelay, this.autoplayPausedUntil - Date.now());

      this.autoplayTimer = setTimeout(() => this.tickAutoplay(), wait);
    }

    /* A manual interaction holds the autoplay for 10 seconds, counted from the last interaction. */
    pauseAutoplay() {
      this.autoplayPausedUntil = Date.now() + this.autoplayPause;
      this.scheduleAutoplay();
    }

    tickAutoplay() {
      const idle = !this.touching && this.autoplayInView && !document.hidden && !this.autoplayReduceMotion.matches;

      if (idle) this.snapToIndex(this.currentIndex() + 1, 'smooth');

      this.scheduleAutoplay();
    }

    bindControls() {
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');

      if (prev) prev.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.currentIndex() + 1));

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(this.shortestPathTo(index)));
      });
    }

    shortestPathTo(index) {
      if (!this.loops) return index;

      const total = this.originals.length;
      const current = this.currentIndex();

      if (index - current > total / 2) return index - total;
      if (current - index > total / 2) return index + total;

      return index;
    }

    buildClones() {
      const narrowest = Math.min(...this.originals.map((slide) => slide.getBoundingClientRect().width)) || 1;
      const visible = Math.ceil(this.track.clientWidth / narrowest);

      this.cloneCount = Math.min(this.originals.length, visible + 1);

      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();

      this.originals.slice(-this.cloneCount).forEach((slide) => {
        before.appendChild(this.makeClone(slide));
      });

      this.originals.slice(0, this.cloneCount).forEach((slide) => {
        after.appendChild(this.makeClone(slide));
      });

      this.track.prepend(before);
      this.track.append(after);
    }

    makeClone(slide) {
      const clone = slide.cloneNode(true);

      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('inert', '');
      clone.dataset.sourceIndex = String(this.originals.indexOf(slide));
      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });
      clone.removeAttribute('data-shopify-editor-block');

      return clone;
    }

    startOf(slide) {
      return (
        slide.getBoundingClientRect().left -
        this.track.getBoundingClientRect().left +
        this.track.scrollLeft
      );
    }

    realIndexOf(slide) {
      if (slide.dataset.sourceIndex !== undefined) return Number(slide.dataset.sourceIndex);

      return this.originals.indexOf(slide);
    }

    currentIndex() {
      let closest = this.slides[0];
      let distance = Infinity;

      this.slides.forEach((slide) => {
        const delta = Math.abs(this.startOf(slide) - this.track.scrollLeft);

        if (delta < distance) {
          distance = delta;
          closest = slide;
        }
      });

      return this.realIndexOf(closest);
    }

    targetFor(index) {
      if (this.loops) {
        const bounded = Math.max(-this.cloneCount, Math.min(this.originals.length + this.cloneCount - 1, index));

        return this.slides[this.cloneCount + bounded];
      }

      return this.slides[Math.max(0, Math.min(this.slides.length - 1, index))];
    }

    snapToIndex(index, behavior) {
      this.track.scrollTo({ left: this.startOf(this.targetFor(index)), behavior });
    }

    goTo(index) {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.snapToIndex(index, reduceMotion ? 'instant' : 'smooth');
    }

    onScroll() {
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), 100);

      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.realIndex = this.currentIndex();

        this.dots.forEach((dot, index) => {
          if (index === this.realIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      });
    }

    releaseTouch() {
      this.touching = false;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), 100);
    }

    settle() {
      if (!this.loops || this.touching) return;

      const firstReal = this.startOf(this.slides[this.cloneCount]);
      const firstTrailing = this.startOf(this.slides[this.cloneCount + this.originals.length]);
      const span = firstTrailing - firstReal;
      let position = this.track.scrollLeft;

      if (position < firstReal - 2) {
        position += span;
      } else if (position >= firstTrailing - 2) {
        position -= span;
      }

      const nearest = this.slides
        .map((slide) => this.startOf(slide))
        .reduce((best, start) => (Math.abs(start - position) < Math.abs(best - position) ? start : best));

      if (Math.abs(nearest - this.track.scrollLeft) > 2) {
        this.track.scrollTo({ left: nearest, behavior: 'instant' });
      }
    }
  }

  if (!customElements.get('content-slider')) {
    customElements.define('content-slider', ContentSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer-base"] && !Shopify.designMode) return;
  try {
    window.BarkitaDrawer = class BarkitaDrawer {
    constructor(element, options = {}) {
      this.element = element;
      this.options = options;
      this.panel = element.querySelector('.drawer__panel');
      this.opener = null;
      this.inerted = [];

      element.addEventListener('click', (event) => {
        if (event.target.closest('[data-drawer-close]')) this.close();
      });

      element.addEventListener('keydown', (event) => this.onKeydown(event));
    }

    get isOpen() {
      return this.element.classList.contains('is-open');
    }

    open(opener) {
      if (this.isOpen) return;

      this.opener = opener || document.activeElement;
      this.inerted = [];

      Array.from(document.body.children).forEach((child) => {
        if (child.contains(this.element) || child.inert) return;

        child.inert = true;
        this.inerted.push(child);
      });

      if (this.options.lockClass) document.documentElement.classList.add(this.options.lockClass);

      requestAnimationFrame(() => {
        this.element.classList.add('is-open');
        this.panel.focus({ preventScroll: true });
      });

      if (this.options.onOpen) this.options.onOpen();
    }

    close() {
      if (!this.isOpen) return;

      this.element.classList.remove('is-open');

      if (this.options.lockClass) document.documentElement.classList.remove(this.options.lockClass);

      this.inerted.forEach((child) => {
        child.inert = false;
      });
      this.inerted = [];

      if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });

      if (this.options.onClose) this.options.onClose();
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        this.close();

        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = Array.from(
        this.panel.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
      ).filter((element) => element.offsetParent !== null);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && (active === first || active === this.panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  document.dispatchEvent(new CustomEvent('barkita-drawer:ready'));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info-modal"] && !Shopify.designMode) return;
  try {
    class ProductInfoModal extends HTMLElement {
    connectedCallback() {
      /* Lives on <body> so that every other page element can be made inert while it is open. */
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);

        return;
      }

      this.whenReady(() => this.init());
    }

    whenReady(callback) {
      const attempt = () => {
        if (window.BarkitaDrawer && document.readyState !== 'loading') {
          callback();

          return true;
        }

        return false;
      };

      if (attempt()) return;

      document.addEventListener('barkita-drawer:ready', attempt);
      document.addEventListener('DOMContentLoaded', attempt);
    }

    init() {
      if (this.drawer) return;

      this.panel = this.querySelector('.product-modal__panel');
      this.body = this.querySelector('[data-modal-body]');
      this.drawer = new window.BarkitaDrawer(this, { lockClass: 'product-modal-open' });
    }

    hasContent(id) {
      return Boolean(this.template(id));
    }

    template(id) {
      return this.querySelector(`template[data-modal-content="${CSS.escape(id)}"]`);
    }

    show(id, opener) {
      const template = this.template(id);

      if (!template || !this.drawer) return;

      this.body.replaceChildren(document.importNode(template.content, true));
      this.body.scrollTop = 0;

      const title = this.body.querySelector('[data-modal-title]');

      if (title) {
        title.id = 'product-modal-title';
        this.panel.setAttribute('aria-labelledby', 'product-modal-title');
      } else {
        this.panel.removeAttribute('aria-labelledby');
      }

      this.drawer.open(opener);
    }
  }

  if (!customElements.get('product-info-modal')) {
    customElements.define('product-info-modal', ProductInfoModal);

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-modal-open]');

      if (!trigger) return;

      const modal = Array.from(document.querySelectorAll('product-info-modal')).find((element) =>
        element.hasContent(trigger.dataset.modalOpen)
      );

      if (!modal) return;

      event.preventDefault();
      modal.show(trigger.dataset.modalOpen, trigger);
    });

    /* Theme editor: a re-rendered section must not leave its old modal behind on <body>. */
    document.addEventListener('shopify:section:unload', (event) => {
      document.querySelectorAll(`product-info-modal[data-section-id="${CSS.escape(event.detail.sectionId)}"]`).forEach((element) => {
        element.remove();
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    class ScrollReveal extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      if (window.Shopify && window.Shopify.designMode) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const duration = 700;
      const skip = 'dialog, cart-drawer, mobile-menu, floating-cta, [data-reveal-skip]';
      const sections = document.querySelectorAll('body > .shopify-section:not(.shopify-section-group-header-group)');

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const section = entry.target;

            this.observer.unobserve(section);
            section.classList.add('is-revealed');
            setTimeout(() => section.classList.remove('reveal', 'is-revealed'), duration + 100);
          });
        },
        { rootMargin: '0px 0px -12% 0px' }
      );

      sections.forEach((section) => {
        if (!section.offsetHeight || section.querySelector(skip)) return;
        if (section.getBoundingClientRect().top < window.innerHeight) return;

        section.classList.add('reveal');
        this.observer.observe(section);
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('scroll-reveal')) {
    customElements.define('scroll-reveal', ScrollReveal);
  }
  } catch(e) { console.error(e); }
})();

})();
